import { useQuery } from '@tanstack/react-query';
import { playbooksApi } from '../api/playbooks';

export function usePlaybooks() {
  return useQuery({
    queryKey: ['playbooks'],
    queryFn: playbooksApi.list,
    staleTime: 10 * 60_000, // curated content, changes rarely
  });
}
